// extracted by mini-css-extract-plugin
export default {"form":"BookItemForm_form__5CEqs","input":"BookItemForm_input__wg8B7"};